import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';
import { ModalDefinition } from '../../../services/overlay.service';

import { AbstractListComponent } from '../../shared/abstract-list.component';
import { Project } from '../../../interfaces/project';
import { ProjectService } from '../../../services/project.service';
import { CustomField } from '../../../interfaces/publication';

@Component({
	selector: 'library-project-list',
	templateUrl: './library-project-list.component.html',
	styleUrls: ['./library-project-list.component.scss'],
	providers: [BbTableService]
})

export class LibraryProjectListComponent extends AbstractListComponent implements OnInit {

	putRightSub: Subscription;
	putRight: boolean;
	filterConfig: BbFilterConfiguration;
	// mainMediaClip: Mediaclip;
	// private getClipSub: Subscription;

	constructor(
		protected bbTableService: BbTableService,
		private projectService: ProjectService
	) {

		super(bbTableService);

		this.listConfiguration = {
			name: 'project',
			basePath: '/library/project',
			activePath: '/library/projects',
			entityTranslation: this.translate.instant('PROJECT').toLowerCase(),
			entitiesTranslation: this.translate.instant('PROJECTS').toLowerCase()
		};
		// the presets are not being used yet in the html template
		this.filterConfig = {
			search: true,
			filters: this.projectService.getFilterConfigOptions(),
			presets: [{
				label: this.translate.instant('ALL'),
				value: 'all',
				filterSet: [],
			},
			{
				label: this.translate.instant('PUBLISHED'),
				value: 'published',
				filterSet: [{
					filters: [{
						type: 'project',
						field: 'status',
						operator: 'is',
						value: 'published'
					}]
				}],
			},
			{
				label: this.translate.instant('DRAFT'),
				value: 'draft',
				filterSet: [{
					filters: [{
						type: 'project',
						field: 'status',
						operator: 'is',
						value: 'draft'
					}]
				}],
			}]
		};

		this.subscriptions.add(this.authenticationService.getAllowedCustomFields().subscribe((fields: CustomField[]) => {
			fields.forEach((field: CustomField) => {
				// map custom field type to filter type
				let filterType: string;

				switch (field.itype) {
					case 'text':
						filterType = 'text';
						break;
					case 'number':
						filterType = 'number';
						break;
					case 'date':
						filterType = 'date';
						break;
					case 'checkbox':
						filterType = 'boolean';
						break;
					case 'list':
					case 'string':
						filterType = 'select';
						break;
				}

				if (filterType) {
					this.filterConfig.filters.push({
						property: field.name,
						label: field.label,
						type: filterType
					});
				}
			});
		}));
	}

	ngOnInit() {

		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();

		this.subscriptions.add(this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight));

		this.subscriptions.add(this.authenticationService.hasPermission('cloning').subscribe(hasRight => {
			if (hasRight) {
				this.bbTableService.setSelect(BbTableSelectOption.multi);
			}
		}));
	}

	showPreview(project: Project) {

		const modal: ModalDefinition = {
			icon: 'paper-plane',
			title: project.title || project.name,
			component: {
				name: 'embed-preview',
				inputs: {
					project,
					configuration: {
						standAlone: true,
						autoPlay: false,
						alwaysShow: true
					}
				}
			}
		};
		this.overlayService.createModal(modal);
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (row && row.data && row.data.id) {
			this.router.navigate(['library/project', row.data.id, 'metadata']);
		}
	}

}
